import { get_axios_instance, api_variables,errorHandler } from '@/apis/variables.js';

var axios_instance_download_bulk_data = get_axios_instance(api_variables.SERVICE_BULK_EDIT_MASTER_DATA_DOWNLOAD);
var axios_instance_upload_bulk_data = get_axios_instance(api_variables.SERVICE_BULK_EDIT_MASTER_DATA_UPLOAD);

//const _pk_name = "id";

const state = {
  data:{},
  exits: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
  },
  setExits: (state, payload) => {
    if(payload) {
      state.exits = payload;
    }
  },
  addEmployee: (state, payload) => {
    state.data = payload;
    // state.data.push(payload);
  },
  setFetching: (state, payload) => {
    state.isFetching = payload;
  },
  setSaving: (state, payload) => {
    state.isSaving = payload;
  },
  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const actions = {
    async downloadBulkData({ commit }, payload) {
        try {
            let res = await axios_instance_download_bulk_data.post('', {
              
                columns: payload.columns,
                le_id:payload.leid
            });
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            if (res.data.status) {
                const link = document.createElement("a");
                link.href = res.data.payload;
                link.setAttribute("download", "Bulk_Master_Data.xlsx"); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async uploadTemplate({ commit }, payload) {
        try {
          let res = await axios_instance_upload_bulk_data.post(``, payload);
          return res;
        } catch (err) {
          throw errorHandler(err.response);
        }
      },
}

export default {
  namespaced: true,
  state, mutations, actions
}
// export default {
//     namespaced: true,
//     modules: {}
// }